"use client";

import { c as _c } from "react/compiler-runtime";
import { api } from "@agroproj/backend/convex/_generated/api";
import { useQuery } from "convex/react";
import { Section } from "@/components/ui/section";
import { StatGrid, StatTile, StatValueSkeleton } from "@/components/ui/stat";
import { formatCurrencyBRL } from "@/lib/format";

/**
 * Aggregated project money totals for the organization dashboard (values in reais).
 * `pending` renders the loading state without querying, before Convex auth is ready.
 */
export function FinancialSummary(t0) {
  const $ = _c(20);
  const {
    subscriptionLocked: t1,
    pending: t2
  } = t0;
  const subscriptionLocked = t1 === undefined ? false : t1;
  const pending = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== pending || $[1] !== subscriptionLocked) {
    t3 = subscriptionLocked || pending ? "skip" : {};
    $[0] = pending;
    $[1] = subscriptionLocked;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const projectDashboard = useQuery(api.projects.queries.getProjectsDashboard, t3);
  const isLoading = pending || !subscriptionLocked && projectDashboard === undefined;
  const t4 = projectDashboard?.totalInvestment ?? 0;
  let T0;
  let T1;
  let t5;
  let t6;
  let t7;
  if ($[3] !== isLoading || $[4] !== projectDashboard?.totalRevenue || $[5] !== subscriptionLocked || $[6] !== t4) {
    const items = [{
      label: "Investimento estimado",
      value: t4,
      tone: "default" as const
    }, {
      label: "Receita bruta esperada",
      value: projectDashboard?.totalRevenue ?? 0,
      tone: "positive" as const
    }];
    T1 = Section;
    t7 = "Resumo financeiro";
    T0 = StatGrid;
    t5 = isLoading || undefined;
    t6 = items.map(item => <StatTile key={item.label} label={item.label} tone={item.tone} value={isLoading ? <StatValueSkeleton className="w-32" /> : subscriptionLocked ? "-" : formatCurrencyBRL(item.value)} />);
    $[3] = isLoading;
    $[4] = projectDashboard?.totalRevenue;
    $[5] = subscriptionLocked;
    $[6] = t4;
    $[7] = T0;
    $[8] = T1;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    T0 = $[7];
    T1 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
  }
  let t8;
  if ($[12] !== T0 || $[13] !== t5 || $[14] !== t6) {
    t8 = <T0 aria-busy={t5}>{t6}</T0>;
    $[12] = T0;
    $[13] = t5;
    $[14] = t6;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== T1 || $[17] !== t7 || $[18] !== t8) {
    t9 = <T1 title={t7}>{t8}</T1>;
    $[16] = T1;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}